/////////////Handles both Add and Edit modes based on riskMatrix prop
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
  Box,
  MenuItem,
  FormControl,
  InputLabel,
  FormHelperText,
  Autocomplete,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import AddCancelDialogButtons from "components/AddCancelDialogButtons";

const AddStrategicRoadmapDialog = ({ open, onClose, handleSubmit, activeKpis }) => {
  const { t } = useTranslation();
  const [sourceKpi, setSourceKpi] = useState(null);
  const [targetKpi, setTargetKpi] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  // Populate fields for edit or clear for add
  useEffect(() => {
    // if (strategicInfo) {
    //   setSourceKpi(strategicInfo.sourceKpi || "");
    //   setTargetKpi(strategicInfo.targetKpi || "");
    // } else {
    setSourceKpi(null);
    setTargetKpi(null);
    // }
    //   }, [strategicInfo]);
  }, []);

  const validate = () => {
    const tempErrors = {};
    if (!sourceKpi) {
      tempErrors.sourceKpi = t("Source Kpi is Required");
    }
    if (!targetKpi) {
      tempErrors.targetKpi = t("Target Kpi is Required");
    }
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleClose = () => {
    setSourceKpi(null);
    setTargetKpi(null);
    setErrors({});
    onClose();
  };

  const handleSave = async () => {
    if (!validate()) return;
    setLoading(true);

    // const data = {
    //   ...strategicInfo, // used if in edit mode
    //   sourceKpi,
    //   targetKpi,
    //   companyId: compId,
    // };

    // const isAdd = !strategicInfo;
    // await handleSubmit(data, isAdd);
    await handleSubmit({
      sourceKpi: sourceKpi[0], // id
      targetKpi: targetKpi[0], // id
    });
    handleClose();
    setLoading(false);
    // handleClose();
  };

  const renderKpiOptions = () =>
    activeKpis.map(([id, kpiNameId, kpiName]) => (
      <MenuItem key={id} value={id}>
        {kpiName}
      </MenuItem>
    ));

  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      <DialogTitle>
        {
          // strategicInfo
          //   ? t("admin.strategicInfo.dialog.editTitle")
          t("admin.strategicInfo.strategicRoadmap.addDialog.title")
        }
      </DialogTitle>

      <DialogContent>
        <Autocomplete
          options={activeKpis}
          getOptionLabel={(option) => option[2] || ""}
          value={sourceKpi}
          onChange={(event, newValue) => setSourceKpi(newValue)}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t("admin.strategicInfo.strategicRoadmap.addDialog.sourceKpi")}
              margin="normal"
              fullWidth
              error={!!errors.sourceKpi}
              helperText={errors.sourceKpi}
            />
          )}
        />

        <Autocomplete
          options={activeKpis}
          getOptionLabel={(option) => option[2] || ""}
          value={targetKpi}
          onChange={(event, newValue) => setTargetKpi(newValue)}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t("admin.strategicInfo.strategicRoadmap.addDialog.targetKpi")}
              margin="normal"
              fullWidth
              error={!!errors.targetKpi}
              helperText={errors.targetKpi}
            />
          )}
        />
      </DialogContent>

      <AddCancelDialogButtons
        onCancel={handleClose}
        onSubmit={handleSave}
        loading={loading}
        cancelLabel={t("common.cancel")}
        submitLabel={t("common.add")}
      />

      {loading && (
        <Box display="flex" justifyContent="center" p={2}>
          <CircularProgress size={20} />
        </Box>
      )}
    </Dialog>
  );
};

AddStrategicRoadmapDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  //   strategicInfo: PropTypes.object,
  handleSubmit: PropTypes.func.isRequired,
  activeKpis: PropTypes.array.isRequired,
};

export default AddStrategicRoadmapDialog;
